import type { CSSProperties } from 'react';
import styles from './Skeleton.module.css';

export type SkeletonProps = {
  /** CSS genislik degeri ('100%', '8rem'…). */
  width?: string;
  /** CSS yukseklik degeri. Metin satirlari icin varsayilan yeterli. */
  height?: string;
  shape?: 'line' | 'block' | 'circle';
  className?: string;
};

export function Skeleton({ width = '100%', height, shape = 'line', className }: SkeletonProps) {
  const style: CSSProperties = { width };
  if (height !== undefined) style.height = height;

  return (
    <span
      className={[styles.skeleton, styles[shape], className].filter(Boolean).join(' ')}
      style={style}
      aria-hidden="true"
    />
  );
}

/** Liste iskeleti — kart listeleri icin hazir tekrar. */
export function SkeletonList({ rows = 3 }: { rows?: number }) {
  return (
    <div className={styles.list}>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} shape="block" height="72px" />
      ))}
    </div>
  );
}
